module.exports = __webpack_public_path__ + "static/media/logo.bf88cda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/logo.png
// module id = 288
// module chunks = 0